module.exports = __webpack_public_path__ + "media/images/countryrect/bi-54119039e3c70f5772002f4df0626955.svg";